import { NavLink } from 'react-router-dom';
import { cn } from '@kainos/ui';
import type { NavItemDefinition } from './nav-items';

export interface NavItemProps {
  item: NavItemDefinition;
  attentionCount?: number;
  onNavigate?: () => void;
}

/** Sidebar row: 18px icon, label, and an optional count pill on the right. */
export function NavItem({ item, attentionCount, onNavigate }: NavItemProps) {
  const Icon = item.icon;

  return (
    <NavLink
      to={item.to}
      end={!item.matchPrefix}
      onClick={onNavigate}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-3 rounded-[9px] px-3 py-2.5 text-left text-[13.5px] font-semibold transition-colors',
          isActive ? 'bg-primary-soft text-brand' : 'text-ink-muted hover:bg-line-subtle',
        )
      }
    >
      <Icon size={18} strokeWidth={1.8} className="shrink-0" aria-hidden="true" />
      <span className="min-w-0 flex-1 truncate">{item.label}</span>
      {item.showAttentionCount && attentionCount ? (
        <span className="rounded-full bg-danger px-1.5 py-px text-[10.5px] font-bold text-white">
          {attentionCount}
        </span>
      ) : null}
    </NavLink>
  );
}
